// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { combineReducers } from 'redux';
import { StateType } from 'typesafe-actions';

import cartReducer from './reducers/cartReducer';
import homeReducer from './reducers/homeReducer';
import labInformationReducer from './reducers/labInformationReducer';
import challengeInformationReducer from './reducers/challengeInformationReducer';
import examInformationReducer from './reducers/examInformationReducer';
import LabReviewsReducer from './reducers/LabReviewsReducer';
import LabRelatedReducer from './reducers/LabRelatedReducer';
import onlineCourseFeedbackReducer from './reducers/onlineCourseFeedbackReducer';
import onlineCourseRelatedReducer from './reducers/onlineCourseRelatedReducer';
import searchOnlineCoursesReducer from './reducers/searchOnlineCoursesReducer';
import searchLabsReducer from './reducers/searchLabsReducer';
import searchChallengesReducer from './reducers/searchChallengesReducer';
import searchExamsReducer from './reducers/searchExamsReducer';
import vodListReducer from './reducers/vodListReducer';
import notificationsReducer from './reducers/notificationsReducer';
import runningLabReducer from './reducers/runningLabReducer';
import runningChallengeReducer from './reducers/runningChallengeReducer';
import runningExamReducer from './reducers/runningExamReducer';
import mainLayoutReducer from './reducers/mainLayoutReducer';
import workshopContentsDataReducer from './reducers/workshopContentsDataReducer';
import workshopDataReducer from './reducers/workshopDataReducer';
import onlineCourseContentsDataReducer from './reducers/onlineCourseContentsDataReducer';
import onlineCourseDataReducer from './reducers/onlineCourseDataReducer';
import iltCourseContentsDataReducer from './reducers/iltCourseContentsDataReducer';
import iltCourseDataReducer from './reducers/iltCourseDataReducer';
import supportListReducer from './reducers/supportListReducer';
import updateReadSupportReducer from './reducers/updateReadSupportReducer';
import updateSupportStatusReducer from './reducers/updateSupportStatusReducer';
import replySupportReducer from './reducers/replySupportReducer';
import createNewSupportReducer from './reducers/createNewSupportReducer';

export const rootReducer = combineReducers({
  // add other reducer under this line
  notificationsReducer,
  onlineCourseFeedbackReducer,
  onlineCourseRelatedReducer,
  onlineCourseDataReducer,
  iltCourseDataReducer,
  iltCourseContentsDataReducer,
  searchLabsReducer,
  searchChallengesReducer,
  searchExamsReducer,
  searchOnlineCoursesReducer,
  vodListReducer,
  cartReducer,
  homeReducer,
  labInformationReducer,
  challengeInformationReducer,
  examInformationReducer,
  LabReviewsReducer,
  LabRelatedReducer,
  runningLabReducer,
  runningChallengeReducer,
  runningExamReducer,
  mainLayoutReducer,
  workshopContentsDataReducer,
  workshopDataReducer,
  onlineCourseContentsDataReducer,
  supportListReducer,
  updateReadSupportReducer,
  updateSupportStatusReducer,
  replySupportReducer,
  createNewSupportReducer,
});

export type RootState = StateType<typeof rootReducer>;
